import myAxios from "@/utils/request";
export default {
  // 获取专利
  getPatentList(params) {
    return myAxios.post(
      "/api/servicedocking/getservicedockingmodelbyselect",
      params
    );
  },
  batchDeletePatent(params) {
    return myAxios.post("/api/servicedocking/batchdelete", params);
  },
  // 获取金融
  getFinanceList(params) {
    return myAxios.post(
      "/api/financialservicedocking/getfinancialservicedockingmodelbyselect",
      params
    );
  },
  batchDeleteFinance(params) {
    return myAxios.post("/api/financialservicedocking/batchdelete", params);
  },
  // 获取标准服务
  getStandardList(params) {
    return myAxios.post(
      "/api/standardservicedocking/getstandardservicedockingmodelbyselect",
      params
    );
  },
  batchDeleteStandard(params) {
    return myAxios.post("/api/standardservicedocking/batchdelete", params);
  },
  // 获取资质申请
  getQualificationApply(params) {
    return myAxios.post("/api/qualityservice/backselect", params);
  },
  batchDeleteQualificationApply(params) {
    return myAxios.post("/api/qualityservice/batchdelete", params);
  },
  // 资质评估
  getQualificationEvaluate(params) {
    return myAxios.post("/api/evaluation/getlistbyselect", params);
  },
  changeQualificationEvaluateStatus(params) {
    return myAxios.post("/api/evaluation/setevaluationstatus", params);
  },
  getQualificationCount(params) {
    return myAxios.post("/api/evaluation/getevaluationrecordbyselect", params);
  },
  getQualificationCountInfo(params) {
    const { id } = params;
    return myAxios.get("/api/evaluation/getevaluationrecorddetail?id=" + id);
  },
  getQualificationScoreCount(params) {
    return myAxios.post(
      "/api/evaluation/getevaluationpointrecordbyselect",
      params
    );
  },
  getQualificationScoreCountInfo(params) {
    const { id } = params;
    return myAxios.get("/api/evaluation/getevaluationpointdetail?id=" + id);
  },
  // 获取服务案例
  getCaseList(params) {
    return myAxios.post("/api/servicecase/backsearch", params);
  },
  batchDeleteCase(params) {
    return myAxios.post("/api/servicecase/deleteinfo", params);
  },
  addCase(params) {
    return myAxios.post("/api/servicecase/addoredit", params);
  },
  getCaseInfo(params) {
    const { id } = params;
    return myAxios.get("/api/servicecase/getinfo?id=" + id);
  }
};
